<template>
  <div>
    <form
      id="payment-form"
      method="POST"
      action="https://merchant.com/charge-card"
      class="form-payment"
      :class="{ loading: isLoading }"
    >
      <div v-if="true" class="plan-details-shop w-100">
        <TextBlock
          tag="div"
          class="mb-4 shop-white-tekst"
          style="color: rgba(255, 255, 255, 1); font-size: 1.5rem !important"
        >
          {{ $t(`_web_checkout_shop-payment`, 'Payment') }}
        </TextBlock>
        <div class="divider-payment"></div>
        <div v-if="isPriceLoading" class="block-loading" />
        <div v-if="price.details" class="plan-details w-100">
          <div class="name-amount d-flex justify-content-between mb-4">
            <div>
              <TextBlock
                class="shop-grey-tekst mb-2"
                style="color: rgba(255, 255, 255, 1)"
              >
                {{ plan.name }}
              </TextBlock>
            </div>
            <div class="price">
              <TextBlock
                class="shop-white-tekst"
                style="color: rgba(255, 255, 255, 1)"
                >{{ $$t(price.currency) }}
              </TextBlock>
              <TextBlock
                class="shop-white-tekst"
                style="color: rgba(255, 255, 255, 1)"
              >
                {{ price.details.initialAmount }}
              </TextBlock>
              <!--            $$t('month')-->
            </div>
          </div>
          <div class="coupon d-flex justify-content-between mb-4">
            <HeraInput
              v-model="couponCode"
              :disabled="couponApplied"
              :label="$t(`_web_checkout_shop-promo-code`, 'Promo code')"
              :placeholder="
                $t(`_web_checkout_shop-enter-promocode`, 'Enter promocode')
              "
              :error="couponError"
              :class="{
                'is-invalid': !!couponError,
              }"
              class="coupon-input"
            />
            <Btn
              class="apply-coupon-button btn-accent d-flex align-items-center justify-content-center"
              :label="
                couponApplied
                  ? $t('_web_shop_applied', 'Applied')
                  : $t('_web_shop_applly', 'Apply')
              "
              :loading="isCouponChecking"
              :disabled="!couponCode || couponApplied"
              @click="apply"
            />
          </div>
          <div
            v-if="plan.tax"
            class="subtotal d-flex justify-content-between mb-3"
          >
            <div>
              <TextBlock class="shop-grey-tekst">
                {{ $$t('TAX') }}
              </TextBlock>
            </div>
            <div>
              <TextBlock class="shop-white-tekst">{{
                $$t(plan.currency)
              }}</TextBlock>
              <TextBlock class="shop-white-tekst">
                {{ plan.tax }}
              </TextBlock>
            </div>
          </div>
          <div
            v-if="price.details && price.details.discount"
            class="discount d-flex justify-content-between mb-3"
          >
            <div>
              <TextBlock class="shop-grey-tekst">
                {{ $$t('Discount') }}
              </TextBlock>
            </div>
            <div>
              <TextBlock
                class="shop-white-tekst"
                style="color: rgba(255, 255, 255, 1)"
              >
                {{ price.details.discount }}%
              </TextBlock>
            </div>
          </div>
          <div
            v-if="price.details.couponAmount"
            class="discount d-flex justify-content-between mb-3"
          >
            <div>
              <TextBlock class="shop-grey-tekst">
                {{ $$t('Promo code discount') }}
              </TextBlock>
            </div>
            <div>
              <TextBlock class="shop-white-tekst">{{
                $$t(price.currency)
              }}</TextBlock>
              <TextBlock class="shop-white-tekst">
                {{ price.details.couponAmount.toFixed(2) }}
              </TextBlock>
            </div>
          </div>
          <div class="total d-flex justify-content-between mb-5">
            <div>
              <TextBlock class="shop-grey-tekst">
                {{ $$t('Total') }}
              </TextBlock>
            </div>
            <div class="font-weight-bold">
              <TextBlock
                class="shop-white-tekst"
                style="color: rgba(255, 255, 255, 1)"
                >{{ $$t(price.currency) }}
              </TextBlock>
              <TextBlock
                class="shop-white-tekst"
                style="color: rgba(255, 255, 255, 1)"
              >
                {{ price.amount.toFixed(2) }}
              </TextBlock>
            </div>
          </div>
        </div>
      </div>
      <div class="payment-user-options" style="gap: 30px">
        <div
          v-if="paymentUserOption === ''"
          class="payment-option-wrapper"
          style="min-height: 260px"
        >
          <span class="payment-method" style="color: grey">
            {{ $t('_web_subscription_payment-method', 'Payment Method:') }}
          </span>
          <!-- hardcoded false to applepay-->
          <div
            v-if="$flagsmith.flags.payment_apple_pay_enabled.value && false"
            class="payment-option"
            @click="selectPaymentOptions('applePay')"
          >
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="ApplePay" :width="24" />
              </div>
              <span>{{
                $t('_web_subscription_payment-method-apple pay', 'Apple Pay')
              }}</span>
            </div>

            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
          <!-- Flagsmith dcb payment-->

          <div
            v-if="$flagsmith.flags.dcb_payment.value"
            class="payment-option"
            @click="selectPaymentOptions('mobilePhone')"
          >
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="paywithmobile" :width="24" />
              </div>
              <span>{{
                $t(
                  '_web_subscription_payment-method-dcb',
                  'Pay with Mobile Phone'
                )
              }}</span>
            </div>

            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
          <div
            class="payment-option"
            @click="selectPaymentOptions('creditDebitCard')"
          >
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="cards" :width="24" />
              </div>
              <span>{{
                $t(
                  '_web_subscription_payment-method-creditcard',
                  'Credit/Debit Card'
                )
              }}</span>
            </div>

            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
        </div>
        <div v-if="paymentUserOption === 'mobilePhone'" class="mobile-payment">
          <div v-if="!transaction">
            <div v-if="!transaction" class="button-wrapper-modal mb-5">
              <div
                v-if="!transaction"
                class="text-payment-method d-flex flex-column"
              >
                <span style="color: rgba(255, 255, 255, 0.8)">{{
                  $t(
                    `_web_checkout_shop-provide-information`,
                    'Provide Information'
                  )
                }}</span>
              </div>
              <div
                v-if="!transaction"
                class="image-pay-wrapper"
                style="
                  height: unset;
                  width: unset;
                  padding: 7px;
                  cursor: pointer;
                "
                @click="goBackMobile"
              >
                <icon
                  name="arrow-left"
                  :width="24"
                  :style="isRTL ? 'rotate:180deg;' : ''"
                />
              </div>
            </div>

            <span class="verify-label">{{
              $t(`_web_checkout_shop-provider`, 'Provider')
            }}</span>
            <button class="telecom-picker" disabled>
              <icon name="providerPlaceholder" :width="24" />
              {{ providerTelecom }}
            </button>
          </div>
          <InputPhone
            v-if="!transaction"
            v-model="phone"
            name="phone"
            class="mt-5"
            :label="$$t('Mobile Phone (DCB)', 'phone_input_label_dcb')"
          />
          <div v-if="transaction" class="verify-wrapper">
            <div v-if="statusMessage === 'Success'">
              <div class="toast-sucess-payment mb-3">
                {{
                  $t(`_web_checkout_shop-payment-succ`, 'Payment is Sucessfull')
                }}
              </div>
            </div>
            <div v-if="transaction" class="button-wrapper-modal mb-5">
              <div
                v-if="transaction"
                class="text-payment-method d-flex flex-column"
              >
                <span style="color: rgba(255, 255, 255, 0.8)">{{
                  $t(
                    `_web_checkout_shop-verify-transaction`,
                    'Verify Transaction'
                  )
                }}</span>
              </div>
              <div
                v-if="transaction"
                class="image-pay-wrapper"
                style="
                  height: unset;
                  width: unset;
                  padding: 7px;
                  cursor: pointer;
                "
                @click="goBackMobile"
              >
                <icon
                  name="arrow-left"
                  :width="24"
                  :style="isRTL ? 'rotate:180deg;' : ''"
                />
              </div>
            </div>
            <span class="verify-text">{{
              $t(`_web_checkout_shop-pin-code`, 'PIN Code')
            }}</span>
            <InputVerify v-model="code" class="mt-2" tag="form" :count="4" />
            <span
              v-if="statusMessage !== 'Success' && statusMessage.length > 1"
              class="error-message mt-2"
              >{{
                $t(
                  `_web_checkout_shop-payment-failed`,
                  'Payment failed, check your email'
                )
              }}</span
            >
            <div class="verify-text-wrapper mt-5">
              <span class="verify-text">{{
                $t(`_web_checkout_shop-no-code`, `Haven't received the code?`)
              }}</span>
              <button
                class="verify-text-button"
                :disabled="resendDisabled"
                @click="dcbResend"
              >
                {{
                  resendDisabled
                    ? $t(`_web_checkout_shop-resend-in`, `Resend in`) +
                      remainingSeconds
                    : $t(`_web_checkout_shop-resend`, `Resend`)
                }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-show="paymentUserOption === 'creditDebitCard'"
          class="button-wrapper-modal"
        >
          <div class="text-payment-method d-flex flex-column">
            <span style="color: rgba(255, 255, 255, 0.8)">{{
              $t(
                `_web_checkout_shop-payment-information`,
                'Payment Information'
              )
            }}</span>
          </div>
          <div
            class="image-pay-wrapper"
            style="height: unset; width: unset; padding: 7px; cursor: pointer"
            @click="goBack"
          >
            <icon
              name="arrow-left"
              :width="24"
              :style="isRTL ? 'rotate:180deg;' : ''"
            />
          </div>
        </div>
        <div
          v-show="paymentUserOption === 'creditDebitCard'"
          id="element-container"
        ></div>
        <div
          v-show="paymentUserOption === 'creditDebitCard'"
          id="error-handler"
          class="mt-3"
        ></div>
        <div
          v-show="paymentUserOption === 'creditDebitCard'"
          class="server-error"
        >
          {{ error }}
        </div>

        <div
          v-if="paymentUserOption !== 'mobilePhone'"
          class="close-modal-btn-container mt-2"
        >
          <div class="checkbox-spacer">
            <Checkbox v-model="termsState" @change="updatePayButtonState" />
            <label for="termsState" class="terms-label">
              <span class="terms-hover" @click="redirectToTermsPage">
                {{
                  $t(
                    `_web_checkout_shop-terms-cond`,
                    'I have read and agree to the Terms and conditions.'
                  )
                }}
              </span>
            </label>
          </div>
          <Btn
            id="pay-button"
            class="btn-accent d-flex align-items-center"
            icon="shield-check"
            :icon-size="24"
            :label="$t(`_web_checkout_complete-purchase`, 'Complete Purchase')"
            :disabled="
              isLoading ||
                !agreed ||
                !enablePayButton ||
                paymentUserOption === ''
            "
            @click="pay"
          />
          <button class="close-modal-btn" @click.prevent="closeModal">
            {{ $t('web_create-clan_cancel', 'Cancel') }}
          </button>
          <div class="secure-notice">
            <icon
              name="lock-closed"
              :width="24"
              :fill="$scss.colors.secondaryTextBg"
            />
            <TextBlock
              :size="0.875"
              class="mx-3"
              :variant="'muted'"
              style="font-family: Alexandria"
            >
              {{
                $t(
                  '_web_your_payment',
                  'Your payment data is encrypted and secure.'
                )
              }}
            </TextBlock>
          </div>
        </div>
        <div v-else>
          <Btn
            v-if="!transaction"
            class="btn-accent d-flex align-items-center"
            style="width: 100%"
            :label="$t(`_web_checkout_confirm`, 'Confirm')"
            :disabled="phone.length < 8"
            @click="dcb"
          />
          <div v-if="transaction" class="close-modal-btn-container">
            <div class="checkbox-spacer">
              <Checkbox v-model="termsState" @change="updatePayButtonState" />
              <label for="termsState" class="terms-label">
                {{
                  $t(
                    `_web_checkout_shop-terms-cond`,
                    'I have read and agree to the Terms and conditions.'
                  )
                }}
              </label>
            </div>
            <Btn
              class="btn-accent d-flex align-items-center"
              icon="shield-check"
              style="width: 100%"
              :label="
                $t(`_web_checkout_complete-purchase`, 'Complete Purchase')
              "
              :disabled="code.length !== 4 || isLoading || !enablePayButton"
              @click="dcbPayment"
            />
            <button class="close-modal-btn" @click.prevent="closeModal">
              {{ $t('web_create-clan_cancel', 'Cancel') }}
            </button>
            <div class="secure-notice">
              <icon
                name="lock-closed"
                :width="24"
                :fill="$scss.colors.secondaryTextBg"
              />
              <TextBlock
                :size="0.875"
                class="mx-3"
                :variant="'muted'"
                style="font-family: Alexandria"
              >
                {{
                  $t(
                    '_web_your_payment',
                    'Your payment data is encrypted and secure.'
                  )
                }}
              </TextBlock>
            </div>
          </div>
        </div>
        <Preloader
          v-if="isProcessing"
          :is-loading="isProcessing"
          has-backdrop
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { TAP_PUBLIC_KEY } from '@/api/config';
import { translate } from '@/mixins/translate';
import { prop } from '@/utils/factories';
import Checkbox from '@/components/atoms/form/Checkbox.vue';
import InputPhone from '@/components/form/InputPhoneNew';
import InputVerify from '@/components/form/InputVerify';
import flagsmithMixin from '@/mixins/flagsmithMixin';
import Btn from '@/components/atoms/HeraFormBtn';
import TextBlock from '@/components/atoms/TextBlock.vue';
import icon from '@/components/atoms/Icon';
import HeraInput from '@/components/atoms/form/HeraFormTextInput';
// import Checkbox from '@/components/atoms/form/Checkbox';
import Preloader from '@/components/common/HeraListPreloader';
// import { TERMS_LINK } from '@/api/config';

export default {
  name: 'CheckoutCard',
  components: {
    Btn,
    TextBlock,
    icon,
    HeraInput,
    Checkbox,
    Preloader,
    InputPhone,
    InputVerify,
  },
  mixins: [translate('_web_subscription'), flagsmithMixin],
  props: {
    isLoading: prop(Boolean, false),
    error: prop(String, ''),
    plan: prop(Object),
  },
  data() {
    return {
      tap: window.Tapjsli(TAP_PUBLIC_KEY),
      card: {},
      price: {},
      couponCode: null,
      couponError: '',
      couponApplied: false,
      agreed: true,
      isPriceLoading: false,
      isCouponChecking: false,
      isProcessing: false,
      termsState: false,
      enablePayButton: false,
      paymentUserOption: '',
      phone: '',
      transaction: '',
      code: '',
      statusMessage: '',
      resendDisabled: false,
      countdown: 60,
      countdownInterval: null,
      providerTelecom: 'Zain',
      expireMobile: null,
    };
  },
  computed: {
    ...mapGetters(['currentLocale', 'isRTL']),
    // terms() {
    //   return TERMS_LINK;
    // },
    remainingSeconds() {
      return this.countdown + 's';
    },
  },
  watch: {
    paymentUserOption(newVal) {
      newVal === 'creditDebitCard' &&
        !document.getElementById('privateTapElement');
      {
        if (TAP_PUBLIC_KEY && !document.getElementById('privateTapElement')) {
          const elements = this.tap.elements({});
          const style = {
            body: {
              color: '#ffffff',
              backgoundColor: '#0b0e13',
            },

            base: {
              lineHeight: '18px',
              color: 'black',
              fontFamily: 'sans-serif',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
            },
            invalid: {
              color: 'red',
            },
          };
          // input labels/placeholders
          const labels = {
            cardNumber: 'Card Number',
            expirationDate: 'MM/YY',
            cvv: 'CVV',
            cardHolder: 'Card Holder Name',
          };
          //payment options
          const paymentOptions = {
            currencyCode: ['KWD', 'USD', 'SAR'],
            labels: labels,
            TextDirection: 'ltr',
          };
          //create element, pass style and payment options
          const card = elements.create(
            'card',
            { style: style },
            paymentOptions
          );
          //mount element
          card.mount('#element-container');
          //card change event listener
          card.addEventListener('change', function(event) {
            if (event.loaded) {
              console.log('UI loaded :' + event.loaded);
              console.log('current currency is :' + card.getCurrency());
            }
            const displayError = document.getElementById('error-handler');
            if (event.error) {
              displayError.textContent = event.error.message;
            } else {
              displayError.textContent = '';
            }
          });
          this.card = card;
        }
      }
    },

    statusMessage(newVal) {
      if (newVal === 'Success') {
        setTimeout(() => {
          this.closeModal();
        }, 5000);
      }
    },
    expireMobile(newVal) {
      if (newVal) {
        this.startTimer();
      }
    },
  },
  mounted() {
    this.getPrice();
  },
  methods: {
    ...mapActions([
      'checkCoupon',
      'verifyCard',
      'errorNotify',
      'closeModal',
      'mobileSubPayment',
      'mobileSubCharge',
      'resendCodeDCB',
    ]),
    selectPaymentOptions(option) {
      this.paymentUserOption = option;
    },
    getPrice() {
      this.isPriceLoading = true;
      this.checkCoupon({
        subscriptionId: this.plan.id,
      })
        .then(res => {
          this.price = res;
        })
        .catch(error => {
          this.errorNotify(error);
        })
        .finally(() => {
          this.isPriceLoading = false;
        });
    },
    redirectToTermsPage() {
      const baseUrl = '/static/terms/';
      const route = this.isRTL ? 'other' : 'mena';
      const url = `${baseUrl}${route}`;
      window.open(url, '_blank');
    },

    pay() {
      let self = this;
      this.tap.createToken(this.card).then(function(result) {
        if (result.error) {
          // Inform the user if there was an error
          let errorElement = document.getElementById('error-handler');
          errorElement.textContent = result.error.message;
        } else {
          self.isProcessing = true;
          self.tokenized(result);
        }
      });
    },
    apply() {
      this.isCouponChecking = true;
      this.couponError = '';
      this.checkCoupon({
        subscriptionId: this.plan.id,
        coupon: this.couponCode,
      })
        .then(res => {
          if (res) {
            this.price = res;
            this.couponApplied = true;
          }
        })
        .catch(() => {
          this.couponError = this.$$t('Wrong code');
          this.couponCode = null;
        })
        .finally(() => {
          this.isCouponChecking = false;
        });
    },
    tokenized(data) {
      // console.log('optained token: ' + data.id);
      this.$emit(
        'submit',
        data.id,
        this.couponApplied ? this.couponCode : null
      );
    },
    updatePayButtonState() {
      this.enablePayButton = this.termsState;
    },
    dcb() {
      Promise.all([]).then(() => {
        this.mobileSubPayment({
          subscriptionId: this.plan.id,
          phone: this.phone,
          coupon: this.couponCode,
          provider: this.providerTelecom,
        }).then(res => {
          this.transaction = res.transaction;
          this.expireMobile = res.expires;
        });
      });
    },
    dcbResend() {
      if (this.resendDisabled) {
        return;
      }
      this.startCountdown();
      Promise.all([]).then(() => {
        this.resendCodeDCB({
          transaction: this.transaction,
        }).then(() => {
          this.code = '';
          this.enablePayButton = false;
          this.termsState = false;
        });
      });
    },
    dcbPayment() {
      Promise.all([]).then(() => {
        this.mobileSubCharge({
          transaction: this.transaction,
          code: this.code,
        }).then(res => {
          if (res.status === 'failed') {
            this.statusMessage = res.message;
          } else if (res.status === 'Success') {
            this.statusMessage = 'Success';
          } else {
            this.statusMessage = '';
          }

          this.code = '';
          this.enablePayButton = false;
          this.termsState = false;
        });
      });
    },
    startCountdown() {
      this.resendDisabled = true;
      this.countdown = 60;

      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.resendDisabled = false;
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },
    startTimer() {
      if (this.expireMobile) {
        const currentTime = Math.floor(Date.now() / 1000);
        const remainingTime = this.expireMobile - currentTime;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.paymentUserOption = '';
            this.transaction = '';
          }, remainingTime * 100);
        }
      }
    },
    goBack() {
      this.paymentUserOption = '';
    },
    goBackMobile() {
      if (this.transaction.length > 0) {
        this.transaction = '';
        this.phone = '';
      } else {
        this.paymentUserOption = '';
      }
    },
  },
};
</script>

<style lang="scss">
#payment-form {
  #element-container {
    width: 400px;
    max-width: 390px;
    border-radius: 8px;
    overflow: hidden;
    padding: 1rem;
    background: white;
  }

  .coupon {
    .wrapper-control {
      width: 300px;
    }

    .apply-coupon-button {
      margin-top: 27px;
    }
  }

  .coupon-input {
    padding-right: 10px;
  }

  .btn-accent {
    justify-content: center;
  }

  .coupon-input input {
    background-color: #0a0d11;
    border: 1px solid transparent;
  }

  .coupon-input input:focus {
    border: 1px solid $new-bg-primary;
  }

  #error-handler,
  .server-error {
    color: var(--ph-error);
  }

  &.loading {
    cursor: progress;
  }
}

#payment-form,
#element-container,
.modalbackdrop_container {
  max-height: 91vh;
}

@media (max-width: 515px) {
  #payment-form,
  #element-container,
  .modalbackdrop_container {
    width: 100% !important;
    max-height: unset;
  }
}

.close-modal-btn {
  background-color: rgba(218, 0, 0, 1) !important;
  border: none !important;
  color: $hr-bg-modal-btn !important;
  border-radius: 4px;
  font-weight: 700;
  height: 40px !important;
}

.divider-payment {
  height: 2px !important;
  background: rgba(255, 255, 255, 0.2);
  margin: 32px 0;
}

.close-modal-btn-container {
  width: 100%;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  gap: 16px;
  > button {
    font-family: Alexandria;
  }
  > button > span {
    font-family: Alexandria;
  }
  .close-modal-btn {
    width: 100% !important;
    @media (max-width: 515px) {
      gap: 9px;
    }
  }
}

.form-payment {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 32px;

  .plan-details-shop {
    max-width: 400px;
    min-width: 400px;
    @media (max-width: 515px) {
      min-width: unset;
    }
    label,
    span,
    div,
    .coupon-input {
      color: grey;
      font-family: Alexandria !important;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      letter-spacing: -0.18px;
    }
  }
}

.form-payment {
  @media (max-width: 930px) {
    flex-direction: column;
    align-items: center;
  }

  .plan-details-shop {
    .coupon {
      .coupon-input {
        div > span {
          color: #eb6666;
          font-family: Exo;
          font-size: 14px !important;
          font-weight: 400;
          line-height: 24px !important;
          margin: 0px 5px;
        }

        div > input {
          width: 100% !important;
        }

        .wrapper-control-label {
          label {
            color: rgba(255, 255, 255, 0.5) !important;
          }
        }
      }
    }
  }
}

.payment-option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.payment-option {
  display: flex;
  height: 64px;
  padding: 16px 16px 16px 8px;
  gap: 12px;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.option-wrapper {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  > span,
  div {
    font-family: Alexandria;
  }
}

.image-pay-wrapper {
  display: flex;
  padding: 11px;
  width: 46px;
  height: 46px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.06);
}

.payment-user-options {
  border-radius: 16px;
  background-color: #1c212b;
  padding: 32px;
  min-width: 460px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 530px) {
    min-width: 100%;
    padding: 16px;
  }

  .mobile-payment {
    min-height: 240px;

    .verify-wrapper {
      .verify-text-button {
        background-color: transparent;
        border: none;
        width: fit-content;
        padding: 0px;
        font-family: Alexandria;
        font-size: 14px;
        font-weight: 500;
        color: rgba(209, 209, 219, 1);
      }

      .verify-text {
        font-family: Alexandria;
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8);
      }

      .input-verify {
        min-height: unset !important;
      }
    }

    .form-group {
      label {
        font-family: Alexandria;
        font-size: 14px;
        font-weight: 500;
        color: grey;
      }

      .float-dropbox {
        background-color: rgba(51, 55, 64, 1) !important;

        div > .input-search.focused {
          border-bottom-color: unset;
        }

        .list-loader {
          .list-wrapper {
            div {
              max-height: 150px !important;
            }
          }
        }
      }

      .dropbox-list .list-loader .container {
        min-height: 165px;
      }

      .dropbox-list li > :not(hr):hover {
        background-color: rgba(64, 74, 99, 1) !important;
      }

      .float-dropbox.show.float-dropbox-top::after {
        background-color: rgba(51, 55, 64, 1) !important;
      }

      .input-group-prepend {
        button {
          background-color: rgba(255, 255, 255, 0.05) !important;
          height: 2.15rem;
        }
      }

      .hera-input-phone_input:focus {
        box-shadow: unset !important;
      }

      .new-phone-input {
        border-color: rgba(255, 255, 255, 0.04);
        background-color: unset !important;

        input {
          background-color: rgba(255, 255, 255, 0.05) !important;
        }
      }
    }
  }
}

.verify-text-wrapper {
  display: flex;
  flex-direction: column;
}

.verify-label {
  font-family: Alexandria;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  gap: 6px;
}

.telecom-picker {
  border-radius: 4px;
  width: 100%;
  height: 2.15rem;
  border-color: rgba(255, 255, 255, 0.04);
  background-color: rgba(255, 255, 255, 0.05);
  color: white;
  text-align: left;
}

.terms-label,
.payment-method,
.text-payment-method {
  color: rgba(255, 255, 255, 0.5);
  font-family: Alexandria;
  font-size: 14px;
  font-weight: 500;
}

.checkbox-spacer {
  display: flex;
  gap: 12px;
}

.shop-white-tekst {
  color: white;
  font-family: Alexandria;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 20px !important;
  letter-spacing: -0.18px;
}

.shop-grey-tekst {
  color: grey;
  font-family: Alexandria;
  font-size: 14px !important;
  font-weight: 600;
  line-height: 20px !important;
  letter-spacing: -0.18px;
}

.rtl-transform-chevron {
  rotate: 180deg;
}

.error-message {
  color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
  margin-top: 30px;
}
.button-wrapper-modal {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.secure-notice {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss" scoped>
.terms-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
.toast-sucess-payment {
  width: 100%;
  max-width: 100%;
  min-height: 38px;
  padding: 16px;
  border-radius: 8px;
  background: rgb(75, 181, 67);
  color: white;
  border-radius: 8px;
  /* Elevated */
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.07),
    0px 5px 10px 0px rgba(0, 0, 0, 0.05);
}
</style>
